
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tax-exemption",
      function () {
        return require("private-next-pages/tax-exemption/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tax-exemption"])
      });
    }
  